<!-- Conteúdo do menu (cabeçalho + campos agrupados por família), o mesmo no botão que vira
     menu e no popover da pílula entre dois campos. -->
<ng-template #groups>
    <div class="morph-head">
        <span>{{ 'document.edit.toolbar.insertField' | translate }}</span>
        <kbd>{{ 'document.edit.menuOptions.escToClose' | translate }}</kbd>
    </div>

    <!-- Lista agrupada (Texto, Dados, Mídia, Mais), com a cor da família no ícone
         e uma linha dizendo o que cada campo é. -->
    <div class="morph-items">
        @for (group of morphGroups(); track group.key) {
            <div class="morph-group" role="group" [attr.aria-label]="group.label | translate">
                <div class="morph-group-label">{{ group.label | translate }}</div>
                @for (option of group.options; track option.key) {
                    <button
                        type="button"
                        class="morph-option"
                        role="menuitem"
                        [class]="'morph-option family-' + group.key"
                        (click)="option.run()">
                        <!-- Hover: cada campo mostra o que faz (o texto se digita, as
                             barras crescem, o semáforo acende...). -->
                        <span class="morph-option-icon" [attr.data-fx]="option.key">
                            <ra-icon [icon]="option.icon" varColor="currentColor" [size]="18" />
                            @switch (option.key) {
                                @case ('text') {
                                    <span class="fx fx-type" aria-hidden="true">
                                        <span class="fx-type-text">Aa</span>
                                        <span class="fx-caret"></span>
                                    </span>
                                }
                                @case ('stats') {
                                    <span class="fx fx-bars" aria-hidden="true"><i></i><i></i><i></i></span>
                                }
                                @case ('table') {
                                    <span class="fx fx-rows" aria-hidden="true"><i></i><i></i><i></i></span>
                                }
                                @case ('semaphore') {
                                    <span class="fx fx-lights" aria-hidden="true"><i></i><i></i><i></i></span>
                                }
                                @case ('chart') {
                                    <svg class="fx fx-graph" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M3 17.5l5-5.5 4 3 8-8.5" />
                                    </svg>
                                }
                                @case ('folder') {
                                    <svg class="fx fx-check" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M6 12.5l4 4 8-9" />
                                    </svg>
                                }
                            }
                        </span>
                        <span class="morph-option-text">
                            <b>
                                {{ option.label | translate }}
                                @if (option.badge) {
                                    <span class="morph-badge">{{ option.badge | translate }}</span>
                                }
                            </b>
                            <small>{{ option.hint | translate }}</small>
                        </span>
                    </button>
                }
            </div>
        }
    </div>
</ng-template>

@if (!menuOptionsService.isMenuOptionsHidden()) {
    @if (isMorph()) {
        <!-- O botão "Inserir campo" VIRA o menu: o painel nasce recortado no formato do
             botão (a cópia dele fica na base, no mesmo lugar) e cresce até mostrar a lista;
             ao fechar, encolhe de volta para dentro do botão. Sem espaço acima, cresce para
             baixo. Posição e recorte são medidos no componente. -->
        <div
            class="container-menu-options morph"
            role="menu"
            [class.down]="morphDown()"
            [style.top.px]="position()?.top"
            [style.left.px]="position()?.left"
            [style.visibility]="position() ? 'visible' : 'hidden'"
            (animate.leave)="morphOut($event)">
            <div class="morph-surface">
                <ng-container *ngTemplateOutlet="groups" />

                <!-- A cópia do botão: o "+" vira "×" e o texto troca para "Fechar". -->
                <button
                    type="button"
                    class="morph-button"
                    data-menu-trigger
                    (click)="menuOptionsService.hideMenuOptions()">
                    <ra-icon icon="add" varColor="currentColor" [size]="18" />
                    <span class="morph-button-labels">
                        <span class="label-insert" aria-hidden="true">{{ 'document.edit.toolbar.insertField' | translate }}</span>
                        <span class="label-close">{{ 'document.edit.menuOptions.close' | translate }}</span>
                    </span>
                </button>
            </div>
        </div>
    } @else {
        <div
            class="container-menu-options"
            [style.top.px]="position()?.top"
            [style.left.px]="position()?.left"
            [style.visibility]="position() ? 'visible' : 'hidden'"
            animate.enter="menu-enter"
            animate.leave="menu-leave">
            <!-- Popover da pílula entre dois campos: o mesmo menu novo, numa coluna (as duas
                 não cabem na margem ao lado da folha). -->
            <div class="morph-surface popover-surface">
                <ng-container *ngTemplateOutlet="groups" />
            </div>
        </div>
    }
}
